//Provider Service 중 Auditors 관련 전역 Vuex Store

import axios from '@core_utils/api/_axios.js'

const auditors = {
    namespaced: true,
    state: {
        admin_user_space: [],
        is_admin_space_loaded: false
    },
    getters: {},
    mutations: {
        update_space(state, new_user_space){
            state.admin_user_space=new_user_space
            state.is_admin_space_loaded = true
        }
    },
    actions: {
        async initiateSpace ({ commit }, user_id) {
            try {
                const response = await axios.get('/read_admin_user_space', { params: {
                    user_id: user_id
                }})
                let new_user_space = response.data
                new_user_space.forEach(item => {
                    item.value = item.e_mail + ' ' + item.user_name
                })
                commit('update_space', new_user_space )    
            } catch (error) {
                console.log(error)   
            }
        }
    }
}

export default auditors